import { EDemandRequestStep } from './demandRequestStep';

export const DEMAND_MODAL_TITLE = {
  [EDemandRequestStep.DEAL_TYPE]: 'Чем риелтор может вам помочь?',
  [EDemandRequestStep.PHONE]: 'Укажите ваш номер мобильного телефона',
};
